import React, { useState } from 'react';
import { CategorySearch, SearchType } from '../../types';
import { SearchGlass, Carot, XIcon } from './icons';
import { DropdownWrap, MenuItem } from './searchDropdownStyles';
import SearchTypeChooser from './SearchTypeChooser';

export default function SearchDropdown({
  isOpen,
  searchRef,
  categorySearches,
  onSelectSearch,
  selectedSearches,
  closeDropdown,
}: {
  isOpen: boolean;
  searchRef: any;
  categorySearches: CategorySearch[];
  onSelectSearch: (searchType: SearchType) => void;
  selectedSearches: SearchType[];
  closeDropdown: () => void;
}) {
  const [searchText, setSearchText] = useState('');

  return (
    <DropdownWrap isOpen={isOpen} ref={searchRef}>
      <div className="innerWrap">
        <div className="search-section">
          <div className="search-wrap">
            <SearchGlass />
            <input
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              type="text"
              placeholder="Search"
            />
          </div>
          {/* <div className="addButton">+</div> */}
        </div>
        <div style={{ marginTop: 8 }}>
          <SearchTypeChooser
            categorySearches={categorySearches}
            searchText={searchText}
            onSelectSearch={onSelectSearch}
            selectedSearches={selectedSearches.map(s => s.id)}
          />
        </div>
      </div>
    </DropdownWrap>
  );
}
